import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { PageTabs } from '@shared/components';
import { OverviewView, MapExplorerView } from './views'
import styles from './HomePage.module.css';

const tabs = [
  { id: 'map', label: 'Map & assets' },
  { id: 'overview', label: 'Overview' },
]

function HomePage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const requestedView = searchParams.get('homeView');

  const view = tabs.some(tab => tab.id === requestedView)
    ? requestedView
    : 'map';

  useEffect(() => {
    const alreadyNormalized =
      searchParams.get('homeView') === view &&
      !searchParams.has('tab');

    if (alreadyNormalized) return;

    setSearchParams(previous => {
      const next = new URLSearchParams(previous);

      next.set('homeView', view);
      next.delete('tab');

      return next;
    }, { replace: true })
  }, [view, searchParams, setSearchParams])

  function handleViewChange(nextView) {
    if (
      nextView === view ||
      !tabs.some(tab => tab.id === nextView)
    ) {
      return;
    }

    setSearchParams(previous => {
      const next = new URLSearchParams(previous);

      next.set('homeView', nextView);
      next.delete('tab');

      return next;
    });
  }

  return (
    <div className={styles.page}>
      <header className={styles.heading}><div><span>ASSET INTEGRITY</span><h1>Fleet workspace</h1></div>
        <p>Explore locations and open the records behind each asset.</p></header>
      <PageTabs
        id="home-views"
        label="Home views"
        tabs={tabs}
        current={view}
        onChange={handleViewChange}
      />

      <section
        id="home-views-panel-map"
        role="tabpanel"
        aria-labelledby='home-views-tab-map'
        hidden={view !== 'map'}
        tabIndex={0}
        className={styles.panel}
      >
        {<MapExplorerView isActive={view === 'map'} />}
      </section>

      <section
        id='home-views-panel-overview'
        role="tabpanel"
        aria-labelledby='home-views-tab-overview'
        hidden={view !== 'overview'}
        tabIndex={0}
        className={styles.panel}
      >
        {view === 'overview' && <OverviewView />}
      </section>
    </div>
  );
}

export default HomePage;